import React from "react";
import {
  Button,
  MenuItem,
  OutlinedInput,
  Select,
  FormControl,
  InputLabel,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import withModal from "../../Modal";
import MemberGenderTypes from "../../../models/MemberGenderTypes";
import EventAdditionalPriceDefinitions from "../../../models/EventAdditionalPriceDefinitions";
import EventPriceDefinitions from "../../../models/EventPriceDefinitions";
import BookingTeams from "../../../models/BookingTeams";
import { DatePicker } from "@mui/x-date-pickers";
import Constants from "../../../models/Constants";
import { EventOptionAvailabilityTypesEnum } from "../../../models/EventOptionAvailabilityTypes";

class FilterPrices {
  memberAgeGroupId: number;
  memberGroupTypeId: number;
  eventOptionId: number;
  [key: string]: any;
}

class AddItemModal extends React.Component<any, any> {
  componentDidUpdate(prevProps: any) {
    const availabilityId =
      this.props.team === true
        ? EventOptionAvailabilityTypesEnum.Team
        : EventOptionAvailabilityTypesEnum.Einzel;

    if (
      this.props.bookingMember.memberAgeGroupId !==
        prevProps.bookingMember.memberAgeGroupId ||
      this.props.bookingMember.memberGroupTypeId !==
        prevProps.bookingMember.memberGroupTypeId ||
      this.props.bookingMember.eventOptionId !==
        prevProps.bookingMember.eventOptionId
    ) {
      this.props.fetchPrices(
        this.props.bookingMember.memberAgeGroupId,
        this.props.bookingMember.memberGroupTypeId,
        this.props.bookingMember.eventOptionId,
        availabilityId
      );

      this.props.fetchOptions(
        this.props.bookingMember.memberAgeGroupId,
        this.props.bookingMember.memberGroupTypeId
      );

      if (
        this.props.bookingMember.memberAgeGroupId === "" ||
        this.props.bookingMember.memberGroupTypeId === "" ||
        this.props.bookingMember.eventOptionId === ""
      )
        this.props.resetSelectedOptions();
    }
  }

  public render() {
    const genderTypes: JSX.Element[] = (
      this.props.genderTypes as MemberGenderTypes[]
    ).map((x) => {
      return (
        <MenuItem key={x.id} value={x.id}>
          {x.genderName}
        </MenuItem>
      );
    });

    let optionTypes = (
      this.props.options as EventAdditionalPriceDefinitions[]
    ).map((x) => {
      return {
        id: x.eventAdditionalPriceTypeId,
        name: x.eventAdditionalPriceTypeName,
      };
    });
    optionTypes = [...new Set(optionTypes.map((o) => JSON.stringify(o)))].map(
      (s) => JSON.parse(s)
    );

    const options: JSX.Element[] = optionTypes.map((x) => {
      let typeName = (
        this.props.options as EventAdditionalPriceDefinitions[]
      ).filter((y) => y.eventAdditionalPriceTypeId === x.id)[0]
        .eventAdditionalPriceTypeName;
      let menuItems = (this.props.options as EventAdditionalPriceDefinitions[])
        .filter((y) => y.eventAdditionalPriceTypeId === x.id)
        .map((y) => {
          return (
            <MenuItem key={y.id} value={y.id}>
              {y.description} - €{y.priceValue}
            </MenuItem>
          );
        });
      const selectedOptions = (this.props.selectedOptions as EventAdditionalPriceDefinitions[]).filter((y) => y != undefined);

      const selectedOptionsValue =
        selectedOptions.filter((y) => y.eventAdditionalPriceTypeId === x.id)
          .length > 0
          ? selectedOptions.filter(
              (y) => y.eventAdditionalPriceTypeId === x.id
            )[0].id
          : "";
      const selectedOptionsError =
        selectedOptions.filter((y) => y.eventAdditionalPriceTypeId === x.id)
          .length === 0;

      return (
        <FormControl variant="outlined" fullWidth className="mt-2">
          <InputLabel htmlFor="outlined-aktiv">{typeName} *</InputLabel>
          <Select
            input={<OutlinedInput id="outlined-aktiv" fullWidth />}
            value={selectedOptionsValue}
            error={selectedOptionsError}
            onChange={(e: any) => this.props.addOption(e)}
            fullWidth
            name={x.name}
          >
            <MenuItem value="">
              <em>--- bitte auswählen ---</em>
            </MenuItem>
            {menuItems}
          </Select>
        </FormControl>
      );
    });

    const ageGroups: JSX.Element[] = Array.from(
      new Set(
        (this.props.prices as EventPriceDefinitions[]).map(
          (x) => x.memberAgeGroupId
        )
      )
    )
      .map((x) => {
        return {
          memberAgeGroupId: x,
          memberAgeGroupName: this.props.prices.find(
            (s: EventPriceDefinitions) => s.memberAgeGroupId === x
          ).memberAgeGroupName,
          memberAgeFrom: this.props.prices.find(
            (s: EventPriceDefinitions) => s.memberAgeGroupId === x
          ).memberAgeFrom,
          memberAgeTo: this.props.prices.find(
            (s: EventPriceDefinitions) => s.memberAgeGroupId === x
          ).memberAgeTo,
        };
      })
      .map((x) => {
        return (
          <MenuItem key={x.memberAgeGroupId} value={x.memberAgeGroupId}>
            {x.memberAgeGroupName} {x.memberAgeFrom} - {x.memberAgeTo}
          </MenuItem>
        );
      });

    const memberGroups: JSX.Element[] = Array.from(
      new Set(
        (this.props.prices as EventPriceDefinitions[]).map(
          (x) => x.memberGroupTypeId
        )
      )
    )
      .map((x) => {
        return {
          memberGroupTypeId: x,
          memberGroupTypeName: this.props.prices.find(
            (s: EventPriceDefinitions) => s.memberGroupTypeId === x
          ).memberGroupTypeName,
        };
      })
      .map((x) => {
        return (
          <MenuItem key={x.memberGroupTypeId} value={x.memberGroupTypeId}>
            {x.memberGroupTypeName}
          </MenuItem>
        );
      });

    const eventOptions: JSX.Element[] = Array.from(
      new Set(
        (this.props.prices as EventPriceDefinitions[]).map((x) => {
          return { eventOptionId: x.eventOptionId, priceValue: x.priceValue };
        })
      )
    )
      .map((x) => {
        return {
          eventOptionId: x.eventOptionId,
          eventOption: this.props.prices.find(
            (s: EventPriceDefinitions) => s.eventOptionId === x.eventOptionId
          ).eventOption,
          priceValue: x.priceValue,
        };
      })
      .map((x) => {
        return (
          <MenuItem key={x.eventOptionId} value={x.eventOptionId}>
            {x.eventOption} - €{x.priceValue}
          </MenuItem>
        );
      });

    const teams: JSX.Element[] = (
      this.props.bookingTeams as BookingTeams[]
    ).map((x) => {
      return (
        <MenuItem key={x.id} value={x.id}>
          {x.teamName}
        </MenuItem>
      );
    });

    let pickerError = !this.props.bookingMember.birthday ||  isNaN(new Date(this.props.bookingMember.birthday || null).getTime());

    return (
      <div
        className="modal"
        style={{
          display: "block",
          zIndex: 1200,
          position: "fixed",
          top: "20%",
        }}
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <div className="row">
                <div className="col-xs-6 col-sm-6 col-md-6 co-lg-6">
                  {this.props.showGender && (
                    <FormControl variant="outlined" fullWidth className="mt-2">
                      <InputLabel htmlFor="outlined-aktiv">
                        Geschlecht:
                      </InputLabel>
                      <Select
                        input={<OutlinedInput id="outlined-aktiv" fullWidth />}
                        name="gender"
                        error={
                          this.props.validFields.gender != undefined &&
                          !this.props.validFields.gender
                        }
                        value={
                          typeof this.props.bookingMember.gender !== "undefined"
                            ? this.props.bookingMember.gender
                            : ""
                        }
                        onChange={(e: any) => {
                          e.target.value =
                            e.target.value === "" ? null : e.target.value;
                          e.target.name = "gender";
                          return this.props.changeMember(e);
                        }}
                      >
                        <MenuItem value="">
                          <em>--- bitte auswählen ---</em>
                        </MenuItem>
                        {genderTypes}
                      </Select>
                    </FormControl>
                  )}
                  <TextField
                    label="Vorname *"
                    fullWidth
                    className="mt-2"
                    name="firstName"
                    error={!this.props.validFields.firstName}
                    value={this.props.bookingMember.firstName}
                    onChange={(e: any) => this.props.changeMember(e)}
                  />
                  <TextField
                    label="Nachname: *"
                    fullWidth
                    className="mt-2"
                    name="lastName"
                    error={!this.props.validFields.lastName}
                    value={this.props.bookingMember.lastName}
                    onChange={(e: any) => this.props.changeMember(e)}
                  />
                  <TextField
                    label="Telefon"
                    fullWidth
                    className="mt-2"
                    name="phone"
                    value={this.props.bookingMember.phone}
                    onChange={(e: any) => this.props.changeMember(e)}
                  />
                  <TextField
                    label="Bemerkung"
                    fullWidth
                    multiline
                    className="mt-2"
                    name="note"
                    value={this.props.bookingMember.note}
                    onChange={(e: any) => this.props.changeMember(e)}
                  />

                  <DatePicker
                    label="Geburtsdatum:"
                    value={
                      this.props.bookingMember.birthday
                        ? new Date(this.props.bookingMember.birthday)
                        : null
                    }
                    openTo="year"
                    format={Constants.DateFormat}
                    slotProps={{
                      textField: {
                        error: Boolean(pickerError),
                        helperText: pickerError
                          ? "ungültiges Datumsformat"
                          : "",
                      },
                    }}
                    disableFuture
                    onError={(err) => {
                      pickerError = true;
                      this.props.switchSaveButton(true);
                    }}
                    onChange={(date: any) => {
                      if (date !== null) this.props.switchSaveButton(false);
                      else if (
                        date === null &&
                        this.props.validFields.birthday === undefined
                      )
                        this.props.switchSaveButton(false);

                      let dateValue = date !== null ? date : date;

                      let event = {
                        target: {
                          name: "birthday",
                          value: dateValue,
                        },
                      };
                      this.props.changeMember(event);
                    }}
                  />
                </div>
                <div className="col-xs-6 col-sm-6 col-md-6 co-lg-6">
                  {this.props.team && (
                    <>
                      <FormControl
                        variant="outlined"
                        fullWidth
                        className="mt-2"
                      >
                        <InputLabel htmlFor="outlined-aktiv">Team:</InputLabel>
                        <Select
                          input={
                            <OutlinedInput id="outlined-aktiv" fullWidth />
                          }
                          name="teamId"
                          error={
                            typeof this.props.validFields.teamId !=
                              "undefined" && !this.props.validFields.teamId
                          }
                          value={
                            this.props.bookingMember.teamId !== null &&
                            this.props.bookingMember.teamId !== undefined
                              ? this.props.bookingMember.teamId
                              : ""
                          }
                          onChange={(e: any) => {
                            e.target.value =
                              e.target.value === "" ? null : e.target.value;
                            e.target.name = "teamId";
                            return this.props.changeMember(e);
                          }}
                        >
                          <MenuItem value="">
                            <em></em>
                          </MenuItem>
                          {teams}
                        </Select>
                      </FormControl>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="teamLeader"
                            checked={
                              this.props.bookingMember.teamLeader !== null &&
                              this.props.bookingMember.teamLeader !== undefined
                                ? JSON.parse(
                                    this.props.bookingMember.teamLeader
                                  )
                                : false
                            }
                            onChange={(e: any) => {
                              e.target.value = e.target.checked.toString();
                              this.props.changeMember(e);
                            }}
                            disabled={!this.props.enableTeamleaderCheckbox}
                          />
                        }
                        label="Teamleiter"
                      />
                    </>
                  )}
                  <FormControl variant="outlined" fullWidth className="mt-2">
                    <InputLabel htmlFor="outlined-aktiv">
                      Altersklasse: *
                    </InputLabel>
                    <Select
                      input={<OutlinedInput id="outlined-aktiv" fullWidth />}
                      name="memberAgeGroupId"
                      error={!this.props.validFields.memberAgeGroupId}
                      value={
                        this.props.bookingMember.memberAgeGroupId !== null &&
                        this.props.bookingMember.memberAgeGroupId !== undefined
                          ? this.props.bookingMember.memberAgeGroupId.toString()
                          : ""
                      }
                      onChange={(e: any) => {
                        console.log("change memberAgeGroupId", e.target.name);
                        this.props.changeMember(e);
                        if (e.target.value === "") {
                          this.props.changeMember({
                            target: {
                              name: "memberGroupTypeId",
                              value: "",
                            },
                          });
                          this.props.changeMember({
                            target: {
                              name: "eventOptionId",
                              value: "",
                            },
                          });
                          //this.props.fetchPrices('', '', '', availabilityId)
                          //this.props.fetchOptions('', '', '')
                        }
                      }}
                      fullWidth
                    >
                      <MenuItem value="">
                        <em>--- bitte auswählen ---</em>
                      </MenuItem>
                      {ageGroups}
                    </Select>
                  </FormControl>
                  {this.props.bookingMember.memberAgeGroupId !== null &&
                    this.props.bookingMember.memberAgeGroupId !== undefined &&
                    this.props.bookingMember.memberAgeGroupId !== "" && (
                      <FormControl
                        variant="outlined"
                        fullWidth
                        className="mt-2"
                      >
                        <InputLabel htmlFor="outlined-aktiv">
                          Teilnehmergruppe: *
                        </InputLabel>
                        <Select
                          input={
                            <OutlinedInput id="outlined-aktiv" fullWidth />
                          }
                          name="memberGroupTypeId"
                          error={!this.props.validFields.memberGroupTypeId}
                          onChange={(e: any) => {
                            this.props.changeMember(e);
                            if (e.target.value === "") {
                              this.props.changeMember({
                                target: {
                                  name: "eventOptionId",
                                  value: "",
                                },
                              });
                            }
                          }}
                          value={
                            this.props.bookingMember.memberGroupTypeId !==
                              null &&
                            this.props.bookingMember.memberGroupTypeId !==
                              undefined
                              ? this.props.bookingMember.memberGroupTypeId.toString()
                              : ""
                          }
                          fullWidth
                        >
                          <MenuItem value="">
                            <em>--- bitte auswählen ---</em>
                          </MenuItem>
                          {memberGroups}
                        </Select>
                      </FormControl>
                    )}
                  {this.props.bookingMember.memberAgeGroupId !== null &&
                    this.props.bookingMember.memberAgeGroupId !== undefined &&
                    this.props.bookingMember.memberAgeGroupId !== "" &&
                    this.props.bookingMember.memberGroupTypeId !== null &&
                    this.props.bookingMember.memberGroupTypeId !== undefined &&
                    this.props.bookingMember.memberGroupTypeId !== "" && (
                      <FormControl
                        variant="outlined"
                        fullWidth
                        className="mt-2"
                      >
                        <InputLabel htmlFor="outlined-aktiv">
                          Veranstaltung: *
                        </InputLabel>
                        <Select
                          input={
                            <OutlinedInput id="outlined-aktiv" fullWidth />
                          }
                          name="eventOptionId"
                          error={!this.props.validFields.eventOptionId}
                          value={
                            this.props.bookingMember.eventOptionId !== null &&
                            this.props.bookingMember.eventOptionId
                              ? this.props.bookingMember.eventOptionId.toString()
                              : ""
                          }
                          onChange={(e: any) => {
                            this.props.changeMember(e);
                            // this.props.fetchPrices(this.props.bookingMember.memberAgeGroupId,
                            //                         this.props.bookingMember.memberGroupTypeId,
                            //                         e.target.value,
                            //                         availabilityId)
                          }}
                          fullWidth
                        >
                          <MenuItem value="">
                            <em>--- bitte auswählen ---</em>
                          </MenuItem>
                          {eventOptions}
                        </Select>
                      </FormControl>
                    )}
                  {this.props.bookingMember.memberAgeGroupId !== null &&
                    this.props.bookingMember.memberAgeGroupId !== undefined &&
                    this.props.bookingMember.memberAgeGroupId !== "" &&
                    this.props.bookingMember.memberGroupTypeId !== null &&
                    this.props.bookingMember.memberGroupTypeId !== undefined &&
                    this.props.bookingMember.memberGroupTypeId !== "" &&
                    this.props.bookingMember.eventOptionId !== null &&
                    this.props.bookingMember.eventOptionId !== undefined &&
                    this.props.bookingMember.eventOptionId !== "" && (
                      <>{options}</>
                    )}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <Button
                className="btn"
                color="secondary"
                variant="contained"
                onClick={() => this.props.hide()}
              >
                {this.props.team ? "Beenden" : "Abbrechen"}
              </Button>
              <Button
                className="btn"
                color="primary"
                variant="contained"
                disabled={this.props.disableSaveButton && pickerError}
                onClick={() => this.props.submit()}
              >
                Hinzufügen
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withModal(AddItemModal);
